import * as cmtplContractApi from '../../api/cmtplContractApi';
import {
  createCmtplDraft,
  fetchCmtplDraftContractByToken,
  saveVehicleContractInCache,
  updateCmtplDraft,
} from '../../api/contractApi';
import { convertCmtplContractToStoreFormat } from '../../helpers/cmtpl/cmtplContractHelpers';
import { cmtplCalculatorReducerForContract } from './cmtplCalculator';
import {
  CASCO_COVERAGES,
  DURATION_TYPES,
  CMTPL_CASCO_EMPTY_AMOUNTS,
  CMTPL_CASCO_EMPTY_DISCOUNTS,
  CMTPL_EMPTY_PRICES,
  MONTHS,
  OWN_USE_TYPE,
  DEFAULT_SEAT_COUNT,
  CMTPL_CASCO_EMPTY_PRICES,
} from '../../constants/cmtplCalcConstants';
import { PAYMENT_FREQUENCIES, SINGLE } from '../../constants/paymentFrequency';

const SEARCH_DRAFT_DATA = 'efes/cmtplContract/SEARCH_DRAFT_DATA';
const SEARCH_DRAFT_DATA_SUCCESS = 'efes/cmtplContract/SEARCH_DRAFT_DATA_SUCCESS';
const SEARCH_DRAFT_DATA_FAIL = 'efes/cmtplContract/SEARCH_DRAFT_DATA_FAIL';

const GET_VEHICLE_USE_TYPES = 'efes/cmtplContract/GET_VEHICLE_USE_TYPES';
const GET_VEHICLE_USE_TYPES_SUCCESS = 'efes/cmtplContract/GET_VEHICLE_USE_TYPES_SUCCESS';
const GET_VEHICLE_USE_TYPES_FAIL = 'efes/cmtplContract/GET_VEHICLE_USE_TYPES_FAIL';

const GET_BM = 'efes/cmtplContract/GET_BM';
const GET_BM_SUCCESS = 'efes/cmtplContract/GET_BM_SUCCESS';
const GET_BM_FAIL = 'efes/cmtplContract/GET_BM_FAIL';

const GET_BANKS_LIST = 'efes/cmtplContract/GET_BANKS_LIST';
const GET_BANKS_LIST_SUCCESS = 'efes/cmtplContract/GET_BANKS_LIST_SUCCESS';
const GET_BANKS_LIST_FAIL = 'efes/cmtplContract/GET_BANKS_LIST_FAIL';

const SET_CMTPL_DETAILS = 'efes/cmtplContract/SET_CMTPL_DETAILS';
const SET_BM = 'efes/cmtplContract/SET_BM';

const SET_HAS_AGREED = 'efes/cmtplContract/SET_HAS_AGREED';
const SET_HAS_AGREED_TO_SHARE_PERSONAL_DATA = 'efes/cmtplContract/SET_HAS_AGREED_TO_SHARE_PERSONAL_DATA';
const SET_DRAFT_DATA = 'efes/cmtplContract/SET_DRAFT_DATA';

const SAVE_DRAFT_CONTRACT = 'efes/cmtplContract/SAVE_DRAFT_CONTRACT';
const SAVE_DRAFT_CONTRACT_SUCCESS = 'efes/cmtplContract/SAVE_DRAFT_CONTRACT_SUCCESS';
const SAVE_DRAFT_CONTRACT_FAIL = 'efes/cmtplContract/SAVE_DRAFT_CONTRACT_FAIL';

const SAVE_CMTPL_CONTRACT_IN_CACHE = 'efes/cmtplContract/SAVE_CMTPL_CONTRACT_IN_CACHE';
const SAVE_CMTPL_CONTRACT_IN_CACHE_SUCCESS = 'efes/cmtplContract/SAVE_CMTPL_CONTRACT_IN_CACHE_SUCCESS';
const SAVE_CMTPL_CONTRACT_IN_CACHE_FAIL = 'efes/cmtplContract/SAVE_CMTPL_CONTRACT_IN_CACHE_FAIL';

const CONTINUE_FROM_DRAFT = 'efes/cmtplContract/CONTINUE_FROM_DRAFT';
const GET_DRAFT_CMTPL_CONTRACT = 'efes/cmtplContract/GET_DRAFT_CMTPL_CONTRACT';
const GET_DRAFT_CMTPL_CONTRACT_SUCCESS = 'efes/cmtplContract/GET_DRAFT_CMTPL_CONTRACT_SUCCESS';
const GET_DRAFT_CMTPL_CONTRACT_FAIL = 'efes/cmtplContract/GET_DRAFT_CMTPL_CONTRACT_FAIL';

const CLEAR_DRAFT_DATA = 'efes/cmtplContract/CLEAR_DRAFT_DATA';
const CLEAR_CMTPL_CONTRACT = 'efes/cmtplContract/CLEAR_CMTPL_CONTRACT';
const SET_PAYMENT_METHOD = 'efes/cmtplContract/SET_PAYMENT_METHOD';

const SET_COVERAGE_FILES = 'efes/cmtplCalc/SET_COVERAGE_FILES';

const initialState = {
  contractData: {
    draftData: {
      firstName: '',
      lastName: '',
      idNumber: '',
      plateNumber: '',
      policyHolderId: null,
      policyHolderType: '',
      horsePower: '',
      vehicleMark: '',
      vehicleModel: '',
      suggestedStartDate: null,
      email: '',
      phone: '',
      token: '',
      bank: null,
      bankAccountNumber: '',
      useType: null,
    },
    epoliceData: {
      owner: {
        lastName: '',
        firstName: '',
        identification_no: '',
        birth_date: '',
        sex: '',
        scn: '',
      },
      vehicle: {
        number: '',
        vehicle_type: '',
        model_name: '',
        model: '',
        body_type: '',
        body_num: '',
        vin: '',
        engine_hp: null,
        cert_num: '',
        recording_date: '',
        color: '',
        released: '',
      },
    },
    ekengData: {
      passportFrom: '',
      passportGiven: '',
      passportValidUntil: '',
      passport: '',
      citizenship: {
        CountryName: '',
        CountryCode: '',
        CountryShortName: '',
      },
      firstNameEn: '',
      lastNameEn: '',
      firstName: '',
      lastName: '',
      nationalityName: '',
      building: '',
      buildingType: '',
      street: '',
      apartment: '',
      state: null,
      cityVillage: null,
      country: null,
    },
    bm: null,
    cmtplDetails: {
      prices: CMTPL_EMPTY_PRICES,
      paymentFrequencies: {},
      paymentFrequency: PAYMENT_FREQUENCIES[SINGLE],
      cascoPrices: CMTPL_CASCO_EMPTY_PRICES,
      cascoAmounts: CMTPL_CASCO_EMPTY_AMOUNTS,
      cascoDiscounts: CMTPL_CASCO_EMPTY_DISCOUNTS,
      selectedCoverages: CASCO_COVERAGES,
      selectedSeatCount: DEFAULT_SEAT_COUNT,
      isInvalidSeatCount: true,
      isFetchingCascoPrice: false,
      cascoPriceError: false,
      isFetchingPrice: false,
      priceError: null,
      idNumber: '',
      plateNumber: '',
      useType: OWN_USE_TYPE,
      duration: MONTHS.MAX,
      durationType: DURATION_TYPES.MONTH,
      suggestedStartDate: null,
      startDate: null,
      endDate: null,
      contractDays: 0,
      coverageFiles: [],
      uploadedCoverageFiles: [],
      paymentsSchedule: { standard: {} },
    },
  },
  vehicleUseTypes: [],
  banksList: [],
  isFetchingVehicle: false,
  isFetchingVehicleUseTypes: false,
  isFetchingBM: false,
  bmError: null,
  draftDataError: null,
  isFetchingBanksList: false,
  vehicleUseTypesError: null,
  banksListError: null,
  hasAgreed: false,
  hasAgreedToSharePersonalData: false,
  paymentMethod: '',
  savingContractInCache: false,
  draftToken: null,
  draftId: '',
  orderId: null,
  loadingDraftContract: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SEARCH_DRAFT_DATA:
      return {
        ...state,
        isFetchingVehicle: true,
      };
    case SEARCH_DRAFT_DATA_SUCCESS:
      return {
        ...state,
        isFetchingVehicle: false,
        contractData: {
          ...state.contractData,
          draftData: {
            ...state.contractData.draftData,
            ...action.result.draftData,
            plateNumber: action.plateNumber,
            yellowNumber: action.yellowNumber,
          },
          epoliceData: {
            ...state.contractData.epoliceData,
            ...action.result.epoliceData,
          },
          ekengData: {
            ...state.contractData.ekengData,
            ...action.result.ekengData,
          },
        },
      };
    case SEARCH_DRAFT_DATA_FAIL:
      return {
        ...state,
        isFetchingVehicle: false,
        draftDataError: action.error.response,
      };
    case GET_VEHICLE_USE_TYPES:
      return {
        ...state,
        isFetchingVehicleUseTypes: true,
      };
    case GET_VEHICLE_USE_TYPES_SUCCESS:
      return {
        ...state,
        isFetchingVehicleUseTypes: false,
        vehicleUseTypes: action.result,
      };
    case GET_VEHICLE_USE_TYPES_FAIL:
      return {
        ...state,
        isFetchingVehicleUseTypes: false,
        vehicleUseTypesError: action.error.response,
      };
    case GET_BM:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          bm: action.result,
        },
        isFetchingBM: true,
      };
    case GET_BM_SUCCESS:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          bm: action.result,
        },
        isFetchingBM: false,
      };
    case GET_BM_FAIL:
      return {
        ...state,
        isFetchingBM: false,
        bmError: action.error.response,
      };
    case GET_BANKS_LIST:
      return {
        ...state,
        isFetchingBanksList: true,
      };
    case GET_BANKS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingBanksList: false,
        banksList: action.result,
      };
    case GET_BANKS_LIST_FAIL:
      return {
        ...state,
        isFetchingBanksList: false,
        banksListError: action.error.response,
      };
    case SET_CMTPL_DETAILS:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          cmtplDetails: {
            ...state.contractData.cmtplDetails,
            ...action.data,
          },
        },
      };
    case SET_BM:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          bm: action.data,
        },
      };

    case SET_DRAFT_DATA:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          draftData: {
            ...state.contractData.draftData,
            ...action.data,
          },
        },
      };
    case SET_HAS_AGREED:
      return {
        ...state,
        hasAgreed: action.data,
      };
    case SET_HAS_AGREED_TO_SHARE_PERSONAL_DATA:
      return {
        ...state,
        hasAgreedToSharePersonalData: action.data,
      };
    case SAVE_DRAFT_CONTRACT_SUCCESS:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          draftId: action.result,
        },
      };
    case SAVE_CMTPL_CONTRACT_IN_CACHE:
      return {
        ...state,
        draftToken: null,
        orderId: null,
        savingContractInCache: true,
      };
    case SAVE_CMTPL_CONTRACT_IN_CACHE_SUCCESS:
      return {
        ...state,
        draftToken: action.result.draftToken,
        orderId: action.result.id,
        savingContractInCache: false,
      };
    case SAVE_CMTPL_CONTRACT_IN_CACHE_FAIL:
      return {
        ...state,
        draftToken: null,
        orderId: null,
        savingContractInCache: false,
        ...action.backendErrors,
      };
    case GET_DRAFT_CMTPL_CONTRACT:
      return {
        ...state,
        loadingDraftContract: true,
      };
    case GET_DRAFT_CMTPL_CONTRACT_SUCCESS:
      return {
        ...state,
        contractData: { ...state.contractData, ...action.result },
        hasAgreed: action.result.hasAgreed,
        loadingDraftContract: false,
      };
    case GET_DRAFT_CMTPL_CONTRACT_FAIL:
      return {
        ...state,
        loadingDraftContract: false,
      };
    case CONTINUE_FROM_DRAFT:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          ...action.data,
        },
      };
    case CLEAR_DRAFT_DATA:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          draftData: initialState.contractData.draftData,
          epoliceData: initialState.contractData.epoliceData,
          ekengData: initialState.contractData.ekengData,
          cmtplDetails: {
            ...state.contractData.cmtplDetails,
            cascoPrices: CMTPL_CASCO_EMPTY_PRICES,
            cascoAmounts: CMTPL_CASCO_EMPTY_AMOUNTS,
            cascoDiscounts: CMTPL_CASCO_EMPTY_DISCOUNTS,
          },
        },
      };
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.data,
      };
    case SET_COVERAGE_FILES:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          cmtplDetails: {
            ...state.contractData.cmtplDetails,
            coverageFiles: action.data,
          },
        },
      };
    case CLEAR_CMTPL_CONTRACT:
    default:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          cmtplDetails: cmtplCalculatorReducerForContract(state.contractData.cmtplDetails, action),
        },
      };
  }
}

export function getDraftCmtplContract(id, token) {
  return {
    actions: [
      { type: GET_DRAFT_CMTPL_CONTRACT },
      { type: GET_DRAFT_CMTPL_CONTRACT_SUCCESS },
      { type: GET_DRAFT_CMTPL_CONTRACT_FAIL },
    ],
    promise: fetchCmtplDraftContractByToken(id, token),
  };
}

export const saveDraftContract = () => (dispatch, getStore) => {
  const { contractData } = getStore().cmtplContract;
  const { draftId } = contractData;
  return dispatch({
    actions: [
      { type: SAVE_DRAFT_CONTRACT },
      { type: SAVE_DRAFT_CONTRACT_SUCCESS },
      { type: SAVE_DRAFT_CONTRACT_FAIL },
    ],
    promise: draftId ? updateCmtplDraft(contractData) : createCmtplDraft(contractData),
  });
};

export function saveCmtplContractInCache() {
  return (dispatch, getStore) => {
    const { contractData } = getStore().cmtplContract;
    dispatch({ type: SAVE_CMTPL_CONTRACT_IN_CACHE });
    return saveVehicleContractInCache(contractData)
      .then((result) => {
        dispatch({ type: SAVE_CMTPL_CONTRACT_IN_CACHE_SUCCESS, result });
        return result;
      })
      .catch((error) => {
        dispatch({
          type: SAVE_CMTPL_CONTRACT_IN_CACHE_FAIL,
          showError: true,
          error,
        });
        return Promise.reject();
      });
  };
}

export function getDraftCmtplContractAndSaveInCache(id, token) {
  return (dispatch) => dispatch(getDraftCmtplContract(id, token))
    .then(() => dispatch(saveCmtplContractInCache()));
}

export const continueFromDraft = (draft) => {
  const contract = convertCmtplContractToStoreFormat(draft);
  return {
    type: CONTINUE_FROM_DRAFT,
    data: contract,
  };
};

export const clearDraftData = () => ({ type: CLEAR_DRAFT_DATA });

export const getDraftData = (data) => (dispatch) => {
  dispatch(clearDraftData());
  dispatch({
    actions: [
      { type: SEARCH_DRAFT_DATA },
      {
        type: SEARCH_DRAFT_DATA_SUCCESS,
        plateNumber: data.plateNumber,
        yellowNumber: data.yellowNumber,
      },
      {
        type: SEARCH_DRAFT_DATA_FAIL,
        showError: true,
      },
    ],
    promise: cmtplContractApi.searchVehicle(data, true),
  });
};

export const getVehicleUseTypes = () => (dispatch) => {
  dispatch({
    actions: [
      { type: GET_VEHICLE_USE_TYPES },
      { type: GET_VEHICLE_USE_TYPES_SUCCESS },
      {
        type: GET_VEHICLE_USE_TYPES_FAIL,
        showError: true,
      },
    ],
    promise: cmtplContractApi.fetchVehicleUseTypes(),
  });
};

export const getBM = (policyHolderId) => (dispatch) => {
  dispatch({
    actions: [
      { type: GET_BM },
      { type: GET_BM_SUCCESS },
      {
        type: GET_BM_FAIL,
        showError: true,
      },
    ],
    promise: cmtplContractApi.getBM(policyHolderId),
  });
};

export const getBanksList = () => (dispatch) => {
  dispatch({
    actions: [
      { type: GET_BANKS_LIST },
      { type: GET_BANKS_LIST_SUCCESS },
      {
        type: GET_BANKS_LIST_FAIL,
        showError: true,
      },
    ],
    promise: cmtplContractApi.fetchBanksList(),
  });
};

export const setBM = (data) => ({
  type: SET_BM,
  data,
});

export const setCmtplDetails = (data) => ({
  type: SET_CMTPL_DETAILS,
  data,
});

export const setCoverageFiles = (data, name) => ({
  type: SET_COVERAGE_FILES,
  data,
  name,
});

export const setHasAgreed = (data) => ({
  type: SET_HAS_AGREED,
  data,
});

export const setHasAgreedToSharePersonalData = (data) => ({
  type: SET_HAS_AGREED_TO_SHARE_PERSONAL_DATA,
  data,
});

export const setDraftData = (data) => ({
  type: SET_DRAFT_DATA,
  data,
});

export const setPaymentMethod = (data) => ({ type: SET_PAYMENT_METHOD, data });
